import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-slate-900">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=2069" 
          alt="Modern architecture" 
          className="w-full h-full object-cover object-center opacity-40 mix-blend-luminosity" 
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/80 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="max-w-3xl">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 border border-amber-600/30 bg-amber-600/10 text-amber-500 text-xs font-semibold tracking-wider uppercase mb-6">
              <span className="w-2 h-2 bg-amber-500 rounded-full animate-pulse"></span>
              Global Advisory Firm
            </div>
            <h1 className="text-5xl md:text-7xl font-serif text-white leading-[1.1] mb-6">
              Navigating Complexity.<br/>
              <span className="text-slate-400">Delivering Excellence.</span>
            </h1>
            <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl font-light leading-relaxed">
              Eldenwyck & Co. provides unparalleled strategic advisory to the world's most ambitious organizations. We turn complex challenges into sustainable competitive advantages.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/services" onClick={() => window.scrollTo(0,0)} className="bg-white text-slate-900 px-8 py-4 font-semibold hover:bg-slate-100 transition-colors flex items-center justify-center gap-2 group">
                Explore Our Services
                <SafeIcon icon={FiIcons.FiArrowRight} className="transition-transform group-hover:translate-x-1" />
              </Link>
              <Link to="/#insights" className="border border-slate-600 text-white px-8 py-4 font-semibold hover:bg-slate-800 transition-colors text-center">
                Read Latest Insights
              </Link>
            </div>
          </motion.div>
        </div>
      </div>

      <motion.div 
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/50 flex flex-col items-center gap-2"
      >
        <span className="text-xs uppercase tracking-widest">Scroll</span>
        <SafeIcon icon={FiIcons.FiChevronDown} className="w-5 h-5" />
      </motion.div>
    </section>
  );
}